import React from 'react';

type SelectWidgetProps = {
  className?: string;
  label?: string;
};

const SelectWidget: React.FC<SelectWidgetProps> = ({ className = '', children, label }) => {
  return (
    <div className={`select-widget-container d-inline-flex text-nowrap ${className}`}>
      {!!label && (
        <small className="select-widget-label">{label}</small>
      )}

      {children}
    </div>
  );
};

export default SelectWidget;
